import { Injectable } from '@angular/core';
import {OpenAiAssistant} from "./assistant/OpenAiAssistant";
import {GeminiAssistant} from "./assistant/GeminiAssistant";
import {HttpClient} from "@angular/common/http";
import {StoreSelectorsService} from "../store-selectors.service";
import {SceneAddService} from "../scene-add.service";
import {
    IAppearance, IBackground,
    IBlur, IBorder, ICRUDCommand,
    ICRUDRecord, ICRUDRecordReply, IGlow, IGradient,
    IPlayerProps, IResource,
    ISceneBlock,
    ISceneTreeSliceResults,
    ISelectedSceneSceneId,
    IShadow, IStationData, IUser
} from "../../interfaces";
import {
    animationFrameScheduler,
    BehaviorSubject,
    concatMap,
    from,
    last,
    Observable,
    observeOn,
    of,
    Subject,
    switchMap
} from "rxjs";
import {
    actionAddResources, actionAddScene, actionCRUDRecord, actionCRUDRecordFailure,
    actionCRUDScene,
    actionUpdateSceneItem
} from "../../store/actions/user.actions";
import {Router} from "@angular/router";
import {MatDialog} from "@angular/material/dialog";
import {TutorialsService} from "../tutorials.service";
import {Assistant} from "./assistant/assistant";
import {catchError, delay, finalize, map, tap} from "rxjs/operators";
import {ContainerService} from "../container.service";
import {componentsDefinition} from "./definitions/components-info";
import {AppService} from "../app.service";
import {LocalStoreService} from "../local-store.service";
import {UserService} from "../user.service";
import {generalInfo} from "./definitions/general-info";
import * as _ from "lodash";
import {SceneMimeTypes} from "../../containers/editor/scene-blocks/mime-constants";
import {preprocessSceneRecord} from "../../common";
import {DialogPopComponent} from "../../components/dialog-pop/dialog-pop.component";
import {TranslocoService} from "@ngneat/transloco";
import {SceneListService} from "../scene-list.service";
import {SceneService} from "../scene.service";



@Injectable({
  providedIn: 'root'
})
export class AiService {
    x = 0;
    y = 0;

    settings;

    user: IUser;
    resources;

    log$ = new Subject();
    showDialog$ = new BehaviorSubject<boolean>(false);
    busy$ = new BehaviorSubject<boolean>(false);

    createImage$ = new Subject();
    imageCreated$;

    sceneCommands$ = new Subject();

    selectPropertyPage$ = new Subject<string>();
    addEffect$ = new Subject();
    removeEffect$ = new Subject();

    assistant: Assistant;


    sceneList;

    m_stations: Array<IStationData>;

    sceneSlice;
    editorWidth;
    editorHeight;

    selectedSceneId;
    selectedItems;
    players;
    tutorials;


    imageUrl = '';
    updatedRes;
    resourceId;
    changelistId;
    resourceBytesTotal;


    constructor(protected http: HttpClient,
                protected dialog: MatDialog,
                protected router: Router,
                protected localStoreService: LocalStoreService,
                protected storeSelector: StoreSelectorsService,
                protected sceneAddService: SceneAddService,
                protected containerService: ContainerService,
                protected tutorialsService: TutorialsService,
                protected appService: AppService,
                protected userService: UserService,
                protected translocoService: TranslocoService,
                protected sceneListService: SceneListService,
                protected sceneService: SceneService) {

        this.storeSelector.getUser().subscribe((i_user: IUser) => {
                this.user = i_user;
        });

        this.storeSelector.getResources().subscribe((r) => {
            this.resources = {};
            r.forEach( resource => {
                this.resources[resource.resource_id] = resource;
            });
        });

        this.storeSelector.getLocalStoreUpdates()
            .subscribe((updates) => {
                this.settings = this.localStoreService.getStorageValConfig('assistant');
            });


        this.storeSelector.getScenes(null, false)
            .subscribe((i_scenes) => {
                this.sceneList = [];
                if (i_scenes != null) {
                    i_scenes.forEach(item => {
                        const player = item.Player;
                        const scene = {
                            sceneId: player.$.id,
                            sceneName: player.$.label
                        };
                        this.sceneList.push(scene);
                    });
                }
            });

        this.storeSelector.listenPlayerDataOfSelectedSceneItemId()
            .subscribe((i_sceneSlice: ISceneTreeSliceResults) => {
                this.sceneSlice = i_sceneSlice;
                this.editorWidth = +this.sceneSlice.sceneItem.Data[0].Layout[0].$.width;
                this.editorHeight = +this.sceneSlice.sceneItem.Data[0].Layout[0].$.height;
            });

        this.storeSelector.listenSelectedSceneIdAndSceneItemId().subscribe((v: ISelectedSceneSceneId) => {
            this.selectedSceneId = v.sceneId;
        });

        this.storeSelector.listenSelectedScene().subscribe((i_scene: IPlayerProps) => {
            if (i_scene && i_scene.Player) {
                this.players = (i_scene.Player.Data["0"]?.Scene["0"]?.Players["0"]?.Player || []) as ISceneBlock[];
            } else {
                this.players = null;
            }
        });

        this.tutorialsService.getData().subscribe(data => {
            this.tutorials = this.tutorialsService.extractVideoItems(data);
        });

        this.containerService.getActiveSceneItemIds().subscribe((_ids) => {
            this.selectedItems = _ids;
        });

        this.storeSelector.getStationsComplete()
            .subscribe((v) => {
                this.m_stations = v || [];
            });
    }

    isDialogVisible() {
        return this.showDialog$.value;
    }

    showDialog(visible) {
        this.showDialog$.next(visible);
    }

    log(txt, showWait = false) {
        const message = {
            wait: showWait,
            text: txt
        };
        this.log$.next(message);
    }


    send(assistantName, prompt): Observable<any> {
        this.busy$.next(true);

        this.assistant = (assistantName == 'openai' ? new OpenAiAssistant() : new GeminiAssistant());

        this.log('you:');
        this.log(prompt + '\n');
        this.assistant.addUserMessage(prompt);

        generalInfo.forEach( msg => {
            this.assistant.addSystemMessage(msg);
        });


        //this.assistant.addSystemMessage("pageId: " + this.router.url);


        if (this.selectedSceneId != null) {
            this.assistant.addSystemMessage("selectedScene Id: " + this.selectedSceneId);
            this.assistant.addSystemMessage("selectedScene Size: " + this.editorWidth + ', ' + this.editorHeight);
            this.assistant.addSystemMessage("when addComponentToScene there is no need to call first getSceneData, call it after the add.");


            this.assistant.addSystemMessage("selectedItems: " + this.selectedItems + ".");
            this.assistant.addSystemMessage("If user ask to update item call 'getSceneData' first.");
            this.assistant.addSystemMessage("for any update select the items first.");

            this.assistant.addSystemMessage("'register player' → call sceneCommand with { 'command': 'REGISTER' }.");
        }





        return this.chat().pipe(
            catchError( err => {
               this.log(err.message);
               return of(null);
            }),
            last(),
            tap( () => {
                this.busy$.next(false);
                this.log('\nfinished.');
            }),
            delay(1000),
            finalize(() => {
                if (this.settings.autoHide) {
                    this.showDialog(false);
                }
            })
        );
    }

    chat(): Observable<any> {
        const prompt = JSON.stringify(this.assistant.getPrompt());
        return this.http.post(this.assistant.getApiUrl(), {
            "json": prompt
        }).pipe(
            switchMap(a => {
                const result: any = JSON.parse((<any> a).reply);
                const functionList = this.assistant.getFunctionList(result);
                return from(functionList).pipe(
                    concatMap(func =>
                        of(func).pipe(
                            observeOn(animationFrameScheduler)
                        )
                    )
                );
            }),
            switchMap(b => {
                const part: any = b;
                if (part.text != null) {
                    this.log(part.text);
                    return of('a');
                } else if (part.functionCall != null) {

                    if (part.functionCall.name != 'thinkingProcess' || this.settings.showThinking) {
                        this.log('assistant:', true);
                        this.log('  ' + part.functionCall.name + "()");
                        let txt = JSON.stringify(part.functionCall.args, null, 4);
                        txt = txt.substring(1, txt.length - 1);
                        this.log(txt + '\n');
                    }
                    const functionId = part.functionCall.id;
                    const functionName = part.functionCall.name;
                    const functionArgs = part.functionCall.args;
                    return this[functionName](functionId, functionName, functionArgs);
                }
            }),
            last(),
            switchMap(a => {
                if (this.assistant.requiredAnotherChat) {
                    this.assistant.requiredAnotherChat = false;
                    return this.chat();
                } else {
                    return of("finish");
                }
            })
        );
    }


    thinkingProcess(functionId, functionName, functionArgs): Observable<any> {
        const result = functionArgs.text;
        this.assistant.addToolCall(functionId, functionName, functionArgs, result);
        return of('a');
    }


    navigateToPage(functionId, functionName, functionArgs): Observable<any> {
        let pageId = functionArgs.pageId;
        
        if (functionArgs.propertyName != null) {
            switch (functionArgs.propertyName) {
                case "sceneId":
                    const sceneId = '/' + functionArgs.propertyValue;
                    pageId += sceneId;
                    break;

                case "helpName":
                    const link = '/' + functionArgs.propertyValue;
                    pageId += link;
                    break;
            }
        }

        this.router.navigate([pageId]);

        const result = "navigated to page: " + this.router.url;
        this.assistant.addToolCall(functionId, functionName, functionArgs, result);

        return of('navigated');
    }


    getComponentsDefinition(functionId, functionName, functionArgs): Observable<any> {
        
        const result = componentsDefinition;
        this.assistant.addToolCall(functionId, functionName, functionArgs, result);

        return of('componentsDefinition');
    }

    getSceneList(functionId, functionName, functionArgs): Observable<any> {
        
        const result = JSON.stringify(this.sceneList);
        this.assistant.addToolCall(functionId, functionName, functionArgs, result);

        return of('sceneList');
    }

    createScene(functionId, functionName, functionArgs): Observable<any> {
        


        const sceneId = _.uniqueId();
        const sceneBlock = this.storeSelector.getBlockLabelByFileType('scene');
        const scene: ISceneBlock = sceneBlock.template;
        const newScene: any = {Player: scene};

        // set scene layout
        newScene.Player.$.id = sceneId;
        newScene.Player.$.player = sceneBlock.id;
        newScene.Player.Data[0].Layout[0].$.width = String(functionArgs.width);
        newScene.Player.Data[0].Layout[0].$.height = String(functionArgs.height);
        newScene.Player.$.label = functionArgs.sceneName;
        newScene.Player.$.mimeType = SceneMimeTypes.Player;


        const saveRecord = preprocessSceneRecord(newScene, null, this.localStoreService.getStorageConfig().studioId, 'add');
        /** create scene and get inserted id */
        return this.userService.crudRecord(saveRecord).pipe(
            switchMap(i_crudReply => {
                

                // change scene player id
                const newPlayerId = String(i_crudReply.id);
                newScene.Player.$.id = newPlayerId;
                newScene.Player.$.lastModified = String(new Date().getTime());
                newScene.Player.$.changelist_id = String(i_crudReply.changelist_id);
                this.storeSelector.dispatch(actionAddScene({player: newScene}));

                const saveRecord2 = preprocessSceneRecord(newScene, null, this.localStoreService.getStorageConfig().studioId, 'add');
                this.crudScene('update', newPlayerId, {player_data_value: saveRecord2.body.player_data_value});
                this.router.navigateByUrl(`editor/scene/${newPlayerId}`);


                const result = "scene created:  sceneId: " + newPlayerId + " sceneName: " + functionArgs.sceneName;
                this.assistant.addToolCall(functionId, functionName, functionArgs, result);

                return of('created');
            })
        );
    }


    private crudScene(command: ICRUDCommand, id, body) {
        const saveRecord: ICRUDRecord = {
            studioId: this.localStoreService.getStorageConfig().studioId,
            command,
            primary: 'player_data_id',
            table: 'player_data',
            body,
            id
        };
        this.storeSelector.dispatch(actionCRUDRecord({saveRecord}));
    }


    selectScenes(functionId, functionName, functionArgs): Observable<any> {
        

        return of("selected").pipe(
            switchMap( a =>  from(this.router.navigateByUrl("/editor/list"))),
            delay(100),
            switchMap( a => {
                debugger
                const list = this.sceneList.filter((i_scene) => {
                    return functionArgs.sceneIds.includes(i_scene.sceneId);
                });

                const sceneIds = list.map(scene => scene.sceneId);
                this.sceneListService.selectScenes(sceneIds);

                const result = JSON.stringify(sceneIds);
                this.assistant.addToolCall(functionId, functionName, functionArgs, result);
                return of('a');
            })
        );

    }

    deleteSelectedScenes(functionId, functionName, functionArgs): Observable<any> {
        
        this.sceneListService.deleteSelected();
        return of('deleted');
    }



    getSceneData(functionId, functionName, functionArgs): Observable<any> {
        
        const result = JSON.stringify(this.players);
        this.assistant.addToolCall(functionId, functionName, functionArgs, result);
        return of('sceneData')
    }

    getHelpInfo(functionId, functionName, functionArgs): Observable<any> {
        
        const result = JSON.stringify(this.tutorials);
        this.assistant.addToolCall(functionId, functionName, functionArgs, result);
        return of('help');
    }


    addComponentToScene(functionId, functionName, functionArgs): Observable<any> {
        
        if (this.selectedSceneId == null) {
            const result = "user must select scene manually first.";
            this.assistant.addToolCall(functionId, functionName, functionArgs, result);

            return of(null);
        }

        const playerId = functionArgs.playerId;
        const block: any = this.sceneAddService.generateBlockData(playerId, "scene");

        const blocks = [
            block.template
        ];

        this.sceneAddService.addScenePlayers(blocks, 0, 0);

        
        const componentId = block.template.$.id;

        const result = "assistant must call again getSceneData() and then call updateComponentProperty() with the new component id: " + componentId + '.';
        this.assistant.addToolCall(functionId, functionName, functionArgs, result);

        return of('added');
    }

    updateComponentProperty(functionId, functionName, functionArgs) {
        

        const itemId = functionArgs.id;
        const playerId = functionArgs.playerId;
        let propertyPath = functionArgs.propertyPath;
        let propertyName = functionArgs.propertyName;
        const propertyValue = functionArgs.propertyValue;


        if (propertyName == null) {
            
            return;
        }

        if (propertyName.toLowerCase() == 'text') {
            propertyPath = 'Data[0].Label[0]';
            propertyName = 'Text[0]';
        }
        /*
        const i1 = propertyPath.indexOf('Text[0]');
        if (i1 != -1) {
        }

         */

        const values = [
            {
                key: propertyName,
                storePath: propertyPath,
                value: propertyValue
            }
        ];
        this.storeSelector.dispatch(actionUpdateSceneItem({
            sceneId: this.selectedSceneId,
            sceneItemId: itemId,
            values: values
        }));
        this.storeSelector.dispatch({type: 'BREAK_MERGE'}); //???

        return of('updated');
    }

    addEffect(functionId, functionName, functionArgs) {
        
        const itemId = functionArgs.id;
        const effectName = functionArgs.effectName;

        return of('addEffect').pipe(
            tap( a => {
                this.selectPropertyPage$.next('effects');
            }),
            delay(100),
            tap( a => {
                this.addEffect$.next(effectName);
            })
        );
    }


    removeEffect(functionId, functionName, functionArgs) {
        
        const itemId = functionArgs.id;
        const effectName = functionArgs.effectName;

        return of('addEffect').pipe(
            tap( a => {
                this.selectPropertyPage$.next('effects');
            }),
            delay(100),
            tap( a => {
                this.removeEffect$.next(effectName);
            })
        );

        return of('removeEffect');
    }

    selectComponent(functionId, functionName, functionArgs) {
        
        const selectedItems = functionArgs.ids;
        this.containerService.activeSceneItemIds.next(selectedItems);


        const result = "assistant should call updateComponentProperty() is needed.";
        this.assistant.addToolCall(functionId, functionName, functionArgs, result);


        return of('selected');
    }


    sceneCommand(functionId, functionName, functionArgs) {
        debugger
        const command = functionArgs.command;
        this.sceneCommands$.next(command);

        return of('done');
    }


    createImage(functionId, functionName, functionArgs) {
        

        this.log('assistant:', true);

        const jsonPayload = {
            prompt: functionArgs.prompt,
            n: 1,
            size: functionArgs.size  // Optional, depends on your backend
        };


        return this.http.post(this.assistant.getGenerateImageUrl(), {
            "json": JSON.stringify(jsonPayload)
        }).pipe(
            switchMap(imageInfo => {
                
                this.log('image created.\n');

                const msg = {
                    functionId, functionName, functionArgs,
                    imageUrl: (<any> imageInfo).imageUrl
                };
                this.createImage$.next(msg);
                //this.showImage((<any> imageInfo).imageUrl, functionArgs.title, functionArgs.size);
                this.imageCreated$ = new Subject();
                return this.imageCreated$;
            })
        );

    }

    downloadImage(imageMessage): Observable<any> {
        

        const bodyInfo = {
            url: imageMessage.imageUrl,
            ext: 'png'
        };

        const saveRecord: any = {
            body: bodyInfo,
            command: "upload",
            primary: "resource_id",
            studioId: this.localStoreService.getStorageConfig().studioId,
            table: "resources",
            ext: 'png'
        };


        this.updatedRes = {
            resource_name: imageMessage.functionArgs.title,
            resource_type: 'png',
            default_player: '3130',
            resource_total_time: 0,
            resource_date_created: new Date().getTime() + '',
            resource_date_modified: new Date().getTime() + '',
            resource_bytes_total: '0',
            access_key: '0',
            tree_path: ''
        };

        return this.userService.crudRecord(saveRecord).pipe(
            switchMap(ret => {
                
                this.resourceId = (<any> ret).id;
                this.changelistId = (<any> ret).changelist_id;
                this.resourceBytesTotal =  (<any> ret).resource_bytes_total;
                const updateRecord: ICRUDRecord = {
                    studioId: this.localStoreService.getStorageConfig().studioId,
                    command: 'update',
                    primary: 'resource_id',
                    table: 'resources',
                    body: this.updatedRes,
                    id: this.resourceId
                };
                return this.userService.crudRecord(updateRecord);
            }),
            switchMap(ret => {
                
                const size = imageMessage.functionArgs.size.split('x');
                this.updatedRes['resource_id'] = String(this.resourceId);
                this.updatedRes['id'] = String(this.resourceId);
                this.updatedRes['changelist_id'] = String((<any> ret).changelist_id);
                this.updatedRes['resource_bytes_total'] = String(this.resourceBytesTotal);
                this.updatedRes['resource_pixel_width'] = size[0];
                this.updatedRes['resource_pixel_height'] = size[1];

                this.storeSelector.dispatch(actionAddResources({data: this.updatedRes as IResource}));


                
                if (this.selectedSceneId != null) {

                    this.sceneAddService.addBlockType = 'BLOCK_RESOURCES';
                    const block: any = this.sceneAddService.generateBlockData(this.resourceId, "png");


                    const blocks = [
                        block.template
                    ];

                    this.sceneAddService.addScenePlayers(blocks, 0, 0);
                }


                
                const result = "Image created";
                this.assistant.addToolCall(imageMessage.functionId, imageMessage.functionName, imageMessage.functionArgs, result);

                this.imageCreated$.next('image-created');
                this.imageCreated$.complete();

                return of('downloaded');

            })
        );

    }

    modifyImage(functionId, functionName, functionArgs) {
        
        this.log('assistant:', true);

        const resourceId = functionArgs.resourceId;
        const resource  = this.resources[resourceId];
        const url = `https://s3-us-west-2.amazonaws.com/oregon-signage-resources/business${this.user.businessId}/resources/${resourceId}.${resource.resource_type}`;




        const jsonPayload = {
            image_url: url,
            prompt: functionArgs.prompt,
            size: functionArgs.size  // Optional, depends on your backend
        };


        return this.http.post(this.assistant.getEditImageUrl(), {
            "json": JSON.stringify(jsonPayload)
        }).pipe(
            switchMap(imageInfo => {
                
                this.log('image modified.\n');
                return of('a');
/*
                const msg = {
                    functionId, functionName, functionArgs,
                    imageUrl: (<any> imageInfo).imageUrl
                };
                this.createImage$.next(msg);
                //this.showImage((<any> imageInfo).imageUrl, functionArgs.title, functionArgs.size);
                this.imageCreated$ = new Subject();
                return this.imageCreated$;

 */
            })
        );


        return of('a');
    }
}
